export const environment = {
  production: true,
  interval: 10000,
  target: "test.wolkenbeeld.nl",
  useDummyData: false
};
